// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"y0-z"};